module.exports = __webpack_public_path__ + "static/media/unilateral_knee.a19d28b9.jpg";